var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCounterStyle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 288.27 288.27",
    style: {
      enableBackground: "new 0 0 288.27 288.27"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010002"
    },
    d: "M89.516,288.27h109.238c43.605,0,79.084-35.474,79.084-79.084V79.084 C277.838,35.474,242.365,0,198.754,0H89.516C45.911,0,10.432,35.474,10.432,79.084v130.102 C10.432,252.797,45.911,288.27,89.516,288.27z M21.31,79.084c0-37.611,30.595-68.206,68.206-68.206h109.238 c37.611,0,68.206,30.595,68.206,68.206v130.102c0,37.611-30.595,68.206-68.206,68.206H89.516 c-37.611,0-68.206-30.595-68.206-68.206C21.31,209.186,21.31,79.084,21.31,79.084z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010002"
    },
    d: "M58.084,137.048h172.103c3.002,0,5.439-2.437,5.439-5.439V48.087c0-3.002-2.437-5.439-5.439-5.439 H58.084c-3.002,0-5.439,2.437-5.439,5.439v83.522C52.645,134.611,55.081,137.048,58.084,137.048z M63.523,53.526h161.225v72.644 H63.523V53.526z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010002"
    },
    d: "M58.084,237.644h74.912c3.002,0,5.439-2.437,5.439-5.439v-72.943c0-3.002-2.437-5.439-5.439-5.439 H58.084c-3.002,0-5.439,2.437-5.439,5.439v72.943C52.645,235.212,55.081,237.644,58.084,237.644z M63.523,164.7h64.034v62.065 H63.523V164.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010002"
    },
    d: "M230.187,153.822h-74.918c-3.002,0-5.439,2.437-5.439,5.439v72.943 c0,3.002,2.437,5.439,5.439,5.439h74.912c3.002,0,5.439-2.437,5.439-5.439v-72.943 C235.626,156.259,233.189,153.822,230.187,153.822z M224.748,226.765h-64.04V164.7h64.034v62.065H224.748z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010002"
    },
    d: "M114.688,190.351l-38.753-0.098c-0.005,0-0.005,0-0.011,0c-2.997,0-5.434,2.426-5.439,5.428 c-0.005,3.002,2.42,5.445,5.428,5.45l38.753,0.098c0.005,0,0.005,0,0.011,0c2.997,0,5.434-2.426,5.439-5.428 C120.122,192.798,117.696,190.362,114.688,190.351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010002"
    },
    d: "M171.352,201.131h15.936v15.936c0,3.002,2.437,5.439,5.439,5.439s5.439-2.437,5.439-5.439v-15.936 h15.942c3.002,0,5.439-2.437,5.439-5.439c0-3.002-2.437-5.439-5.439-5.439h-15.942v-15.942c0-3.002-2.437-5.439-5.439-5.439 s-5.439,2.437-5.439,5.439v15.942h-15.936c-3.002,0-5.439,2.437-5.439,5.439C165.913,198.694,168.35,201.131,171.352,201.131z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounterStyle);
export default __webpack_public_path__ + "static/media/counterStyle.ca5f5a356b92a75d4d6de79f66abc184.svg";
export { ForwardRef as ReactComponent };